import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { B3DsCheckboxDirective } from './b3-ds-checkbox.directive';
import { B3DsDatepickerDirective } from './b3-ds-datepicker.directive';
import { B3DsInputAreaDirective } from './b3-ds-input-area.directive';
import { B3DsInputSearchDirective } from './b3-ds-input-search.directive';
import { B3DsInputSelectDirective } from './b3-ds-input-select.directive';
import { B3DsInputSelectOptionComponent } from './b3-ds-input-select-option.component';
import { B3DsInputTextDirective } from './b3-ds-input-text.directive';
import { B3DsRadioGroupComponent } from './b3-ds-radio-group.component';
import { B3DsToastSingleLineDirective } from './b3-ds-toast-single-line.directive';

/**
 * Habilita o uso dos Web Components do @b3sa/b3-design-system-web
 * nos templates Angular do m├│dulo que o importar.
 */
@NgModule({
  imports: [CommonModule],
  declarations: [
    B3DsCheckboxDirective,
    B3DsDatepickerDirective,
    B3DsInputAreaDirective,
    B3DsInputSearchDirective,
    B3DsInputSelectDirective,
    B3DsInputSelectOptionComponent,
    B3DsInputTextDirective,
    B3DsRadioGroupComponent,
    B3DsToastSingleLineDirective,
  ],
  exports: [
    B3DsCheckboxDirective,
    B3DsDatepickerDirective,
    B3DsInputAreaDirective,
    B3DsInputSearchDirective,
    B3DsInputSelectDirective,
    B3DsInputSelectOptionComponent,
    B3DsInputTextDirective,
    B3DsRadioGroupComponent,
    B3DsToastSingleLineDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class B3DesignSystemWebModule {}
